// src/components/CustomTabs.js

import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Grid, Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SoftTypography from "components/SoftTypography";
import InfoOutline from '@mui/icons-material/InfoOutlined';
import "./style.css";

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '8px',
  padding: '12px 16px',
  margin: '0 4px',
  backgroundColor: '#f0f0f0',
  transition: 'background-color 0.3s, color 0.3s',
  '&.Mui-selected': {
    backgroundColor: '#6200ea', // Active tab background color
    color: 'white !important'
  },
  '&:hover': {
    backgroundColor: '#e0e0e0',
    color: 'black !important'
  },
}));

const CustomTabs = ({ tabsData }) => {
  // Every accordion rendered `tab.content` unconditionally regardless of
  // expanded state, so all tabs' queries fired on mount even though they
  // all start collapsed - `touched` gates content to only mount once a
  // panel has actually been opened at least once, matching the page's
  // existing default-all-collapsed appearance exactly.
  const [touched, setTouched] = useState(() => new Set());

  const handleAccordionChange = (index) => (event, isExpanded) => {
    if (!isExpanded || touched.has(index)) return;
    setTouched((prev) => new Set(prev).add(index));
  };

  return (
    <div style={{ position: "relative" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <Grid container >

          <Grid item xs={12}>
            <Box sx={{ p: 0 }}>
              {tabsData.map((tab, index) => (
                <Accordion key={index} onChange={handleAccordionChange(index)} style={{
                  marginBottom: "10px", width: "100%",
                  padding: "5px 10px",
                  opacity: "0px",
                  border: "1px solid rgba(229, 229, 229, 1)",
                  borderRadius: "15px",

                }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <SoftTypography >
                      <p style={{ color: "black", fontWeight: "bold", display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>{tab.label}</span>
                        {tab.iSection &&
                          <Tooltip title={tab.iSection} placement='top'>
                            <InfoOutline color='disabled' />
                          </Tooltip>
                        }
                      </p>
                      {tab.subLabel &&
                        <p style={{ marginTop: "4px", fontSize: "13px", color: "#626262ff" }}>{tab.subLabel}</p>
                      }
                    </SoftTypography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <SoftTypography>
                      {touched.has(index) ? tab.content : null}
                    </SoftTypography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default CustomTabs;
